import React, { useRef, useEffect, useState } from 'react'
import { Row, Col, Input, Spin, Alert } from 'antd'
import { useSelector } from 'react-redux'
import { handleChange, formatMessage } from '../../utils/common'
import { sortOutSku } from '../../services/Sort/sortout'
import { modalError, destroyModal } from '../../utils/modalUtils'

let instance1 = null
let instance2 = null
const PFItemSortPage = () => {
  const inputRef = useRef(null)
  // const [currentLabel, setCurrentLabel] = useState([])
  const [isBlur, setIsBlur] = useState(false)
  const [spinLoading] = useState(false)
  const [upcValue, setUpcValue] = useState('')
  const commonStore = useSelector(state => state.commonStore)
  const [upcInputReadOnly, setUpcInputReadOnly] = useState(false)
  const [nfcType, setNfcType] = useState('')
  useEffect(() => {
    inputRef.current.focus({
      cursor: 'all'
    })
    window.addEventListener('keydown', onKeyDownBtn) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDownBtn) // 销毁
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onKeyDownBtn = e => {
    switch (e.keyCode) {
      case 13:
        if (instance1) {
          destroyModal(instance1)
          instance1 = null
          // 清空数据
          setUpcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
        }
        if (instance2) {
          destroyModal(instance2)
          instance2 = null
          // 清空数据
          setUpcValue('')
          // 获取焦点
          inputRef.current.focus({
            cursor: 'all'
          })
        }
        break
      default:
        break
    }
  }

  const onKeyDown = e => {
    switch (e.keyCode) {
      case 13:
        // case 229:
        inputRef.current.blur()
        sortSKU()
        break
      default:
        break
    }
  }

  const onFocusFun = e => {
    setUpcInputReadOnly(true)
    setTimeout(() => {
      setUpcInputReadOnly(false)
    }, 100)

    setIsBlur(false)
  }
  const onBlurFun = e => {
    setTimeout(() => {
      inputRef.current.focus({
        cursor: 'all'
      })
    }, 500)
    setIsBlur(true)
  }
  useEffect(() => {
    if (upcValue?.length === 0) {
      setNfcType('')
    }
  }, [upcValue])

  const sortSKU = () => {
    if (upcValue?.length === 0) {
      return
    }
    const params = {
      upc: upcValue
    }
    sortOutSku(params)
      .then(res => {
        if (res.errorCode === '200') {
          if (res.resultData.length > 0) {
            setNfcType(res.resultData[0]?.toUpperCase())
          }
          inputRef.current.focus({
            cursor: 'all'
          })
        }
      })
      .catch(error => {
        if (error.errorCode === '435') {
          instance1 = modalError({
            content: formatMessage(commonStore, 'languageObj.waverun.illegalUPC')
          })
        }
        if (error.errorCode === '433') {
          instance2 = modalError({
            content: formatMessage(commonStore, 'languageObj.waverun.paramEmpty')
          })
        }
      })
  }
  const showError = () => {
    return isBlur && !upcValue
  }
  return (
    <div style={{ height: '100%' }}>
      <div className="">
        <Spin spinning={spinLoading} size="large">
          {showError() ? (
            <Row type="flex" justify="center">
              <Col style={{ textAlign: 'right' }} span={3}></Col>
              <Col span={15}>
                <Alert
                  className="mb15"
                  type="error"
                  message={formatMessage(commonStore, 'languageObj.nsptagLocale.blurTip')}
                  banner
                />
              </Col>
            </Row>
          ) : (
            <div style={{ height: 45 }} className="mb15"></div>
          )}
          <Row>
            <Col span={3}></Col>
            <Col style={{ textAlign: 'left', display: 'flex', alignItems: 'center' }} span={3}>
              UPC：
            </Col>
            <Col span={15}>
              <Input
                value={upcValue}
                ref={inputRef}
                onChange={e => handleChange(e, { setState: setUpcValue })}
                placeholder={formatMessage(commonStore, 'languageObj.nsptagLocale.pleaseScan') + 'UPC'}
                allowClear
                readOnly={upcInputReadOnly}
                onKeyUp={e => onKeyDown(e)}
                onBlur={e => onBlurFun(e)}
                onFocus={e => onFocusFun(e)}
              />
            </Col>
            <Col span={3}></Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
                <div style={{ fontSize: '12px', marginTop: '20px' }}>
                  {formatMessage(commonStore, 'languageObj.sortout.currentResult')}
                </div>
                <div style={{ fontSize: '26px', color: 'black', marginLeft: '10px', marginTop: '20px' }}>{nfcType}</div>
              </div>
            </Col>
          </Row>
        </Spin>
      </div>
    </div>
  )
}
export default PFItemSortPage
